module.exports = __webpack_public_path__ + "img/interface_track_edit.71e9c216.png";